import { TranslateService } from '@ngx-translate/core';
import { SubHeaderService } from '../themes/services/subheader.service';
import { takeUntil, Subject } from 'rxjs';
import { PaginationOptions } from './models/filter.model';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Component, Injector, OnDestroy, OnInit } from '@angular/core';
import { AppInjector } from '@uw/app.injector';
import { ErrorService } from './services/error.service';
import {
  LayoutUtilsService,
  MessageType,
} from '@uw/shared/services/layout-utils.service';

@Component({ template: '', host: { 'data-component': 'base' } })
export class BaseComponent implements OnInit, OnDestroy {
  destroy$ = new Subject();
  router!: Router;
  activatedRoute: ActivatedRoute;
  subHeaderService: SubHeaderService;
  pagination: PaginationOptions = { page: 0, limit: 10 };
  errorService: ErrorService;
  errorMessage = '';

  public layoutUtilsService: LayoutUtilsService;
  public translateService: TranslateService;

  constructor(_injector?: Injector) {
    const injector = _injector || AppInjector.getInjector();

    if (injector) {
      this.router = injector.get(Router);
      this.subHeaderService = injector.get(SubHeaderService);
      this.activatedRoute = injector.get(ActivatedRoute);
      this.errorService = injector.get(ErrorService);
      this.layoutUtilsService = injector.get(LayoutUtilsService);
      this.translateService = injector.get(TranslateService);
    }

  }

  ngOnInit(): void {
    this.errorService.resetError();
    this.subHeaderService.setSubTitle('');
    this.activatedRoute.queryParams
      .pipe(takeUntil(this.destroy$))
      .subscribe((queryParams) => {
        this.parsePaginationParams(queryParams);
      });
  }

  set subHeaderTitle(title: string) {
    this.subHeaderService.setTitle(this.translateService.instant(title));
  }

  set subHeaderSubTitle(subTitle: string) {
    this.subHeaderService.setSubTitle(
      subTitle ? this.translateService.instant(subTitle) : subTitle
    );
  }

  set setPageError(errorMessage: string) {
    this.errorService.setError(this.translateService.instant(errorMessage));
  }

  resetErrors() {
    this.errorService.resetError();
  }

  showError(message: string, parameters?: Record<string, string | number>) {
    this.layoutUtilsService.showNotification(
      this.translateService.instant(message, parameters),
      MessageType.Error
    );
  }

  showSuccess(message: string, parameters?: Record<string, string | number>) {
    this.layoutUtilsService.showNotification(
      this.translateService.instant(message, parameters),
      MessageType.Success
    );
  }

  updatePaginationQueryParameters(): void {
    this.router.navigate([], {
      queryParams: {
        ...this.pagination,
      },
      queryParamsHandling: 'merge',
      relativeTo: this.activatedRoute,
      replaceUrl: true,
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  private parsePaginationParams(params: Params) {
    if (params.page) {
      this.pagination.page = params.page ? parseFloat(params.page) : 0;
    }
    if (params.limit) {
      this.pagination.limit = params.limit ? parseFloat(params.limit) : 10;
    }
    if (params.sort) {
      this.pagination.sort = params.sort;
    }
    if (params.sortColumn) {
      this.pagination.sortColumn = params.sortColumn;
    }
  }

  downLoadFile(data: any, fileName: string = '') {
    const name = fileName !== '' ? fileName : data.filename;

    const element = document.createElement('a');
    // if (window.navigator.msSaveOrOpenBlob) {
    //   //IE11 & Edge
    //   window.navigator.msSaveOrOpenBlob(data.image, name);
    // } else {
      //Other browsers
      element.href = URL.createObjectURL(data);
      element.download = name;
      document.body.appendChild(element);
      element.click();
    // }
  }

  viewFileInNewTab(data: Blob) {
    const element = document.createElement('a');

    //Other browsers
    element.href = URL.createObjectURL(data);
    element.target = '_blank';
    document.body.appendChild(element);
    element.click();
  }
}
